// removed by extract-text-webpack-plugin
module.exports = {"uconnBanner":"styles__uconnBanner___3h1Rr","brand":"styles__brand___CL2x2","redButtonMenu":"styles__redButtonMenu___6UEOB","navItem":"styles__navItem___3gnUp","btn":"styles__btn___Zsd8r","rotate":"styles__rotate___RtyR3","fadein":"styles__fadein___2pELe","slideFromRight":"styles__slideFromRight___3W_6U","waves":"styles__waves___bC1YU"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/UConnBanner/styles.scss
// module id = ./resources/assets/js/components/UConnBanner/styles.scss
// module chunks = 0